

























































import Vue from 'vue'
import { mapActions, mapMutations } from 'vuex'

interface StatisticheComune {
    istat_code: string
    comune: string
    punti_luce: {
        quantita_attesa: number
        quantita_rilevata: number
    }
    semafori: {
        quantita_attesa: number
        quantita_rilevata: number
    }
    quadri: {
        quantita_attesa: number
        quantita_rilevata: number
    }
    regolatori: {
        quantita_attesa: number
        quantita_rilevata: number
    }
    performance: {
        media: number
        giorni_rimanenti: number
    }
    coordinate_di_un_punto: {
        latitudine: number
        longitudine: number
    }
    altro: {
        e_un_comune_bonificato: boolean
    }
}

export default Vue.extend({
    name: 'PuntiLuceModalStatistiche',
    data: () => ({
        comuniStatistiche: Array<StatisticheComune>()
    }),
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapMutations('modal', ['SET_NUOVE_COORDINATE']),
        async caricaStatistiche() {
            const response = await Vue.axios.get('/puntiluce/stato_rilevamenti.json')
            this.comuniStatistiche = response.data
        },
        vaiAlComune(statistiche: StatisticheComune) {
            this.SET_NUOVE_COORDINATE([statistiche.coordinate_di_un_punto.longitudine, statistiche.coordinate_di_un_punto.latitudine])
            this.showModal(null)
        }
    },
    created() {
        this.caricaStatistiche()
    }
})
